export const getHref = (): string => window.location.href;

export const assignHref = (url: string): void => {
  window.location.assign(url);
};
